import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, parseOptions} from '../question-helper';

@Component({
    selector: 'app-question-radio-icons',
    templateUrl: './question-radio-icons.component.html',
    styleUrls: ['./question-radio-icons.component.scss'],
    standalone: false
})
export class QuestionRadioIconsComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() labelText = '';
  @Input() selectedValue: any;
  @Input() showLabel = false;
  @Output() questionAnswer = new EventEmitter();

  uniqueControlName = `radio-icon-name-${newGuid()}`;
  items: any[] = [];

  constructor() { }

  ngOnInit(): void {
    if (this.question) {
      this.items = parseOptions(this.question.options);
    } else if (!this.items?.length) {
      this.items = [
        {class_id: 0, answer: 'Motor Accident', icon: 'assets/icn/class/lg-fire.svg'},
        {class_id: 0, answer: 'Fire', icon: 'assets/icn/class/lg-fire.svg'},
        {class_id: 0, answer: 'Motor Accident', icon: 'assets/icn/class/lg-fire.svg'},
        {class_id: 0, answer: 'Fire', icon: 'assets/icn/class/lg-fire.svg'},
        {class_id: 0, answer: 'Motor Accident', icon: 'assets/icn/class/lg-fire.svg'},
        {class_id: 0, answer: 'Fire', icon: 'assets/icn/class/lg-fire.svg'}
      ];
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue) {
      this.items = parseOptions(changes?.question?.currentValue?.options);
    }
    if (changes?.showLabel?.currentValue) {
      this.showLabel = changes?.showLabel?.currentValue;
    }
    if (changes?.labelText?.currentValue) {
      this.labelText = changes?.labelText?.currentValue;
    }
    if (changes?.readOnly?.currentValue) {
      this.readOnly = changes?.readOnly?.currentValue;
    }
  }

  checkRadio(answer: any): void {
    if (this.question) {
      this.question.answer = answer;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(answer);
    }
  }

}
